import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import 'antd/dist/antd.css';
import { Input, Select, Button, Col, message } from 'antd';
import { RESOURCE } from '../config/constants/alerts';
import { CONTRACT_DATA, SEARCH_CONTRACT } from '../state/lease_contract/types';
import { SearchOutlined } from '@ant-design/icons';
import { spStates } from '../config/constants/contractStates';
import date from '../helpers/date';
import { STATUS } from '../config/constants/states';
import PropTypes from 'prop-types';

const { Option } = Select;
const { formatString } = date;

const SearchContract = ({ contractSought, getContract, clearData, searchData }) => {

  const [filter, setFilter] = useState('contractId');
  const [param, setParam] = useState('');
  const [visible, setVisible] = useState(false);
  const [placeholderText, setPlaceholder] = useState('Ingrese id de contrato');
  message.config({ maxCount: 1 });

  const columns = [
    {
      title: 'ID Contrato',
      dataIndex: 'id',
      width: 200,
    },
    {
      title: 'Propietario',
      dataIndex: 'owner',
    },
    {
      title: 'Rut',
      dataIndex: 'rut',
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
    },
    {
      title: 'Id de transacción',
      dataIndex: 'transactionId',
    },
    {
      title: 'Monto',
      dataIndex: 'total',
    },
    {
      title: 'Estado de contrato',
      dataIndex: 'state',
    },
    {
      title: 'Ver documentos',
      dataIndex: 'action',
      width: 150,
      fixed: 'right',
    },
  ];

  useEffect(() => {
    const data = contractSought.docs && contractSought.docs[0]
      ? contractSought.docs.map((document, index) => ({
        key: index,
        id: document.contractId,
        owner: document.owner.nombre,
        rut: document.owner.rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
        date: formatString(document.createdAt),
        transactionId: document.payment ? document.payment.buyOrder : 'NA',
        total: document.payment ? `$${document.payment.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}` : 'NA',
        state: spStates(document.estado),
        action: <NavLink to={`/contracts/contract_detail/${document._id}`}>Ver detalle</NavLink>,
      }))
      : [];
    searchData({ data, columns });
    if (contractSought.docs && contractSought.docs[0]) setVisible(true);
    if (contractSought === STATUS.ERROR) {
      message.warning('Busqueda sin resultados');
      clearData();
    }
  }, [contractSought]);

  const handleSearch = () => {
    if (param) {
      getContract(filter, param);
    }
  };

  const setPlaceholderText = (id) => {
    switch (id) {
      case 'contractId':
        setPlaceholder('Ingrese id de contrato');
        break;
      case 'idNotarisa':
        setPlaceholder('Ingrese id de Notarisa');
        break;
      case 'rutOwner':
      case 'rutFirmante':
        setPlaceholder('ej 12345678-9');
        break;
      case 'buyOrder':
        setPlaceholder('Ingrese nro de orden de compra');
        break;
      case 'transactionId':
        setPlaceholder('Ingrese nro de transacción');
        break;
      default:
        setPlaceholder('Ingrese id de contrato');
        break;
    }
  };

  const clearTable = () => {
    setVisible(false);
    searchData({});
    clearData();
  };

  return (
    <>
      <Input.Group compact style={{ display: 'flex' }}>
        <Col className="gutter-row mb-2" span={24} >
          <p>Buscar por:</p>
          <Select
            defaultValue="contractId"
            style={{ width: 150 }}
            onChange={(value) => {
              setFilter(value);
              setPlaceholderText(value);
            }}
          >
            <Option value="contractId">Id de contrato</Option>
            <Option value="idNotarisa">Id Notarisa</Option>
            <Option value="rutOwner">RUT propietario</Option>
            <Option value="rutFirmante">RUT firmantes</Option>
            <Option value="buyOrder">Nro de orden</Option>
            <Option value="transactionId">Nro de transacción</Option>
          </Select>
          <Input placeholder={placeholderText} style={{ width: 300 }} onBlur={(event) => setParam(event.target.value)} />
          <Button type="primary" shape="circle" icon={<SearchOutlined />} onClick={handleSearch} />
          {visible && <Button type="link" onClick={clearTable} >Limpiar</Button>}
        </Col>
      </Input.Group>
    </>
  );
};

SearchContract.propTypes = {
  contractSought: PropTypes.object.isRequired,
  getContract: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  searchData: PropTypes.func.isRequired,
};

const data = (state) => ({
  contractSought: state.contract.contractSought,
});

const action = (dispatch) => ({
  getContract: (filter, value) => dispatch({ type: SEARCH_CONTRACT, payload: { filter, value, resource: RESOURCE.SEARCH_CONTRACT } }),
  clearData: () => dispatch({ type: CONTRACT_DATA, payload: {} })
});

export default connect(data, action)(SearchContract);
